import EmbeddedNotFound from './EmbeddedNotFound';

export default EmbeddedNotFound;
